import { createSlice } from "@reduxjs/toolkit";
import {
  createBillingInfo,
  getBillingInfoById,
  updateBillingInfo,
} from "./BillingInfoForm.thunk";

const baseState = {
  billingInfoData: null,
  billingInfoId: null,
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  statusRetrieve: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  statusCreate: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  statusUpdate: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  errorRetrieve: null,
  errorCreate: null,
  errorUpdate: null,
};

const initialState = {
  ...baseState,
};

export const billingInfoFormSlice = createSlice({
  name: "billingInfoForm",
  initialState,
  reducers: {
    setBillingInfoId: (state, action) => {
      state.billingInfoId = action.payload;
    },
    ResetStore: (state) => {
      return { ...baseState };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBillingInfoById.pending, (state) => {
        state.statusRetrieve = "loading";
        state.errorRetrieve = null;
      })
      .addCase(getBillingInfoById.fulfilled, (state, action) => {
        const { billingInfoData, billingInfoId } = action.payload;
        state.billingInfoData = { ...billingInfoData };
        state.billingInfoId = billingInfoId;
        state.statusRetrieve = "succeeded";
        state.errorRetrieve = null;
      })
      .addCase(getBillingInfoById.rejected, (state, action) => {
        state.statusRetrieve = "failed";
        state.errorRetrieve =
          action.payload?.message || "Error retrieving billing info";
        state.billingInfoData = null;
      });
    builder
      .addCase(createBillingInfo.pending, (state) => {
        state.statusCreate = "loading";
        state.errorCreate = null;
      })
      .addCase(createBillingInfo.fulfilled, (state) => {
        state.statusCreate = "succeeded";
        state.errorCreate = null;
        state.billingInfoId = null;
        state.billingInfoData = null;
      })
      .addCase(createBillingInfo.rejected, (state, action) => {
        state.statusCreate = "failed";
        state.errorCreate =
          action.payload?.message || "Error creating billing info";
      });
    builder
      .addCase(updateBillingInfo.pending, (state) => {
        state.statusUpdate = "loading";
        state.errorUpdate = null;
      })
      .addCase(updateBillingInfo.fulfilled, (state) => {
        state.statusUpdate = "succeeded";
        state.errorUpdate = null;
        state.billingInfoId = null;
        state.billingInfoData = null;
      })
      .addCase(updateBillingInfo.rejected, (state, action) => {
        state.statusUpdate = "failed";
        state.errorUpdate =
          action.payload?.message || "Error updating billing info";
      });
  },
});

export const { setBillingInfoId, ResetStore } = billingInfoFormSlice.actions;

export default billingInfoFormSlice.reducer;
